import React, { useState, useContext, useEffect } from "react";
import GlobalContext from "../../../contexts/globalContext";

// Styles //
import "./LandingAccede.scss";

// Services //
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import { getToken, getCmdFormData } from "../../../services/formServices";
import { getEntryDeliveryApi } from "../../../shared/services/CMS.js";
import { getInsideInfo } from "../../../services/contentful";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Components //
import Modal from "../../molecules/modal/modal";
import Loading from "../../atoms/loading/loading";
import ComunidadBanner from "../../molecules/cmd-banner/cmd-banner";
import EventSectionWrapper from "../../organisms/event-wrapper/eventWrapper";
import NewTendenciesSection from "../../organisms/new-tendencies-section/new-tendencies-section";
import CommunitiesStories from "../../organisms/communities-stories/communitiesStories";
import ReliveCardWrapper from "../../organisms/relive-wrapper/reliveWrapper";
import ConectaRedLideres from "../../organisms/connect-to-lider/connect-to-lider";
import ConoceLideres from "../../organisms/conoce-lideres/conoceLideres";

const LandingAccede = (props: any) => {

    const [pageContext, setPageContext] = useState<any>({});

    useEffect(() => {
        const getPageContext = async () => {
            const dataCont: any = await getEntryDeliveryApi(
                "3Rvow1mKPmhoGZf5imIAln"
            );
            dataCont.referenciaCabecera = await getInsideInfo(
                dataCont.referenciaCabecera
            );
            dataCont.referenciaContenido = await getInsideInfo(
                dataCont.referenciaContenido
            );
            dataCont.referenciaContenido = dataCont.referenciaContenido.slice(1);
            setPageContext(dataCont);
        };
        getPageContext();
    }, []);
  
    const Context = useContext(GlobalContext);
    const { isBrowser } = useBrowserMode();
    let defaultLoginData = {
        fullName: "",
        companyRole: "",
        documentId: "",
        email: "",
        mobile: "",
        isRegistered: false,
        hasAccess: false,
        
      };
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [loginData, setLoginData] = useState(defaultLoginData);

    // Guarda los valores de la cuente de gigya que este logueada
    useEffect(() => {
        if (!Context.gigyaContext.gigyaAccount) {
            const timer = setTimeout(() => {
                if (!Context.gigyaContext.gigyaAccount) {
                    Context.gigyaContext.loginComfamaId!();
                }
            }, 2500);
            return () => clearTimeout(timer);
        } else {
            if (isBrowser) {
                if (!isLoggedIn) setIsLoggedIn(true);
                if (Context.gigyaContext.gigyaAccount.profile.email) {
                    const getAccessData = async () => {
                        const token = await getToken(Context?.gigyaContext?.gigyaAccount?.UID);
                        const responseJson: any = await getCmdFormData(Context!.gigyaContext!.gigyaAccount!.data.docNumber, token);
                        const registeredFlag = responseJson.data.answerData ? true : false;
                        const servicesAuthEnabled = !!Context.gigyaContext.gigyaAccount?.data.servicesAuth && Context.gigyaContext.gigyaAccount?.data.servicesAuth.length! > 0;
                        let hasServiceAccess = false;
                        if (servicesAuthEnabled) {
							let svcLst = Context?.gigyaContext?.gigyaAccount?.data.servicesAuth!;
                            for (let service of svcLst) {
								if (service.serviceId == "COMDADEMPL") {
									hasServiceAccess = true;
									break;
								}
                            }
                        }
                        setLoginData({
                            ...loginData,
                            hasAccess: hasServiceAccess,
                            isRegistered: registeredFlag,
                            fullName: Context?.gigyaContext?.gigyaAccount?.profile.firstName + " " + Context?.gigyaContext?.gigyaAccount?.profile.lastName,
                            documentId: Context?.gigyaContext?.gigyaAccount?.data.docNumber!,
                            email: Context?.gigyaContext?.gigyaAccount?.profile.email!,
                            mobile: Context?.gigyaContext?.gigyaAccount?.data.mobile!
                        });
                    }
                    getAccessData();
                }
            }
        }
    }, [Context.gigyaContext.gigyaAccount, Context?.gigyaContext?.gigyaAccount?.profile]);

    const ValidationModal = (props) => {
        return (
            <>
                <Modal
                    image="https://images.ctfassets.net/gkhyeghj07ak/6m03XnZihvm3nFFlJzHZDF/0e4c890b4ca48b89a1ba9b36f2dfbfd3/check-error.png?h=250"
                    title="Lo sentimos, no se pude completar tu registro"
                    textButton="Finalizar"
                    url={"../"}
                >
                    <div className={`o-form-comdadempl__content-modal`}>
                        <p>
                            {props.message}
                        </p>
                    </div>
                </Modal>
            </>
        )
    }

    const renderSwitch = (value : ReferenciaContenido) => {
        switch (value.tipoComponente) {
            case "ComunidadBanner":
                return (
                    <ComunidadBanner {...value} />
                );
            case "TendenciasAccede":
                return (
                    <NewTendenciesSection {...value} />
                );
            case "EventosAccede":
                return (
                    <EventSectionWrapper {...value} />
                );
            case "ConectaRedLideres":
                return (
                    <ConectaRedLideres {...value} />
                );
            case "ConoceLideres":
                return (
                    <ConoceLideres {...value} />
                );
            case "ComunidadHistorias":
                return (
                    <CommunitiesStories {...value} />
                );
            case "ComunidadRevive":
                return (
                    <ReliveCardWrapper {...value} />
                );
        }
    }
    
    const ContentWrapper = () => {
        if (!isLoggedIn) {
          return (
            null
          );
        }
        else if (!loginData.isRegistered && !loginData.hasAccess) {
            return (
                null
            );
        }
        else if (!loginData.isRegistered) {
          return (
              <ValidationModal
                message="Para acceder a la comunidad debes registrarte">
              </ValidationModal>
          );
        }
        else if (!loginData.hasAccess) {
          return (
              <ValidationModal
                message="En este momento tu solicitud de registro a la comunidad se encuentra en proceso de revisión. Recuerda que esto puede tardar hasta 3 días hábiles a partir de tu registro. Te invitamos a intentar acceder en otro momento">
              </ValidationModal>
          );
        }
        else if (loginData.isRegistered && loginData.hasAccess) {
          return (
            <>
                {pageContext.referenciaContenido ? (
                    pageContext.referenciaContenido.map(
                        (value: ReferenciaContenido, index: number) => (
                            renderSwitch(value)
                        )
                    )
                ) : (
                    <Loading />
                )}
            </>
          )
        }
        else {
          return (
              <ValidationModal
                message="Ups. Algo salió mal.">
              </ValidationModal>
          );
        }
    }

    return (
        <>
            {Context.gigyaContext.gigyaAccount && ( <ContentWrapper/> )}
        </>
    );
};

export default LandingAccede;
